var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M43,48H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H43a5.006,5.006,0,0,1,5,5V43A5.005,5.005,0,0,1,43,48ZM11,9.142h0l2.369,26.7,10.6,3.019L34.636,35.84,37,9.142H11ZM24,33.1h0l-6.713-1.8-.409-5.164h3.23l.233,2.613,3.659,1,3.6-1,.4-4.242h-11.3L15.844,14.6l16.313,0-.285,3.246-12.454,0,.287,3.365,11.876,0-.922,10.1L24,33.1Z",
    fill: "#ffb400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.648963e4b50ac11e3324371a8566dbe1.svg";
export { ForwardRef as ReactComponent };